import React from 'react';
import s from './SSLSecurePayment.scss';
import { useComponentsTranslations, useBreakpoint } from '../../../providers';
import { MediaDevices } from '@wix/package-picker-common';
import { SidedIconTrustBuilder } from '../SidedIconTrustBuilder';
export const SSLSecurePayment = () => {
    const { t } = useComponentsTranslations();
    const { currentBreakpoint } = useBreakpoint();
    const titleKey = currentBreakpoint !== MediaDevices.Desktop
        ? 'ssl_certificate.title.non_desktop'
        : 'ssl_certificate.title';
    return (React.createElement(SidedIconTrustBuilder, { title: t(titleKey), description: t('ssl_certificate.information_encryption'), icon: React.createElement("i", { className: s.sslIcon }) }));
};
//# sourceMappingURL=SSLSecurePayment.js.map